export const AUDIT_AREA = 'systemaudit'
export const AUDIT_PATH = `/${AUDIT_AREA}`
export const AUDIT_URL = `/#${AUDIT_PATH}`

export const exportFormatist = [
    { id: 1, name: 'csv' },
    { id: 2, name: 'pdf' },
    { id: 3, name: 'json' }
]

export const systemAuditTheme = {
    statusColors: {
        informational: '#008AC7',
        successful: '#129A96',
        redirection: '#9C6BFF',
        error: '#C43535'
    }
}

export const AUDITLOG_BASE_URL = '/services/plugin-system-audit'
export const SYSTEMAUDIT = '/system_audit'
export const LIVE_USERS = '/live_users'
